import React from 'react';

export interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  /** Select size */
  size?: 'sm' | 'md' | 'lg';
  /** Validation state */
  state?: 'default' | 'error' | 'success';
  /** Full width */
  fullWidth?: boolean;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      size = 'md',
      state = 'default',
      fullWidth = false,
      disabled,
      required,
      className = '',
      children,
      'aria-invalid': ariaInvalid,
      'aria-required': ariaRequired,
      ...rest
    },
    ref
  ) => {
    const classes = [
      'hi-ui-select',
      `hi-ui-select-size-${size}`,
      state !== 'default' && `hi-ui-select-state-${state}`,
      fullWidth && 'hi-ui-select-full-width',
      disabled && 'hi-ui-select-disabled',
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <select
        ref={ref}
        disabled={disabled}
        required={required}
        className={classes}
        aria-invalid={ariaInvalid ?? (state === 'error' ? true : undefined)}
        aria-required={ariaRequired ?? (required ? true : undefined)}
        {...rest}
      >
        {children}
      </select>
    );
  }
);

Select.displayName = 'Select';
